<template>
  <div class="col-12 col-md-auto product-meta order-3 product-parameter">
    <div class="p-3 p-lg-4 h-100">
      <ClientOnly>
        <form action="#" method="POST">
          <table
            class="table table-borderless align-middle"
            v-if="product.__typename == 'ConfigurableProduct'"
          >
            <tr v-for="parameter of options" :key="parameter.id">
              <th>
                <label>{{ parameter.label }}</label>
              </th>
              <td v-if="parameter.attribute_code == 'size'">
                <select
                  class="form-select"
                  id="product-size"
                  aria-label="Kies een optie"
                  v-on:change="
                    processOption(parameter.index, $event.target.value)
                  "
                  :placeholder="$t('select_measure')"
                >
                  <option>{{ $t("choose_option") }}</option>
                  <option
                    v-for="opt of parameter.values"
                    :key="opt.value_index"
                    :label="opt.label"
                    :value="opt.value_index"
                  >
                    {{ opt.label }}
                  </option>
                </select>
              </td>
              <td v-if="parameter.attribute_code != 'size'">
                <select
                  :name="`${parameter.attribute_code}-select`"
                  class="form-select"
                  :id="`${parameter.attribute_code}`"
                  aria-label="Kies een optie"
                  v-on:change="
                    processOption(parameter.index, $event.target.value)
                  "
                  :placeholder="$t('select_measure')"
                >
                  <option>{{ $t("choose_option") }}</option>
                  <option
                    v-for="opt of getUniqueOptions(parameter.values)"
                    :key="opt.value_index"
                    :label="opt.label"
                    :value="opt.value_index"
                  >
                    {{ opt.label }}
                  </option>
                </select>
              </td>
            </tr>
            <tr class="border-bottom">
              <td>&nbsp;</td>
            </tr>
          </table>
          <table class="table table-borderless align-middle">
            <tr class="product-qty">
              <span v-if="!isInStock">
                <h3>{{ $t("sold_out") }}</h3>
                <p>{{ $t("item_out_of_stock") }}</p>
              </span>
              <span v-else>
                <th>
                  <label for="product-qty">{{ $t("number") }}</label>
                </th>
                <td>
                  <div
                    class="input-group"
                    style="padding-left: 32px !important"
                  >
                    <button
                      class="btn productqty-decrement"
                      type="button"
                      @click="quantityDown"
                    >
                      -
                    </button>
                    <input
                      type="text"
                      min="1"
                      class="form-control"
                      :value="quantity"
                      name="quantity"
                      ref="inputQuantity"
                      disabled
                    />
                    <button
                      class="btn productqty-increment"
                      type="button"
                      @click="quantityUp"
                    >
                      +
                    </button>
                  </div>
                </td>
              </span>
              <td class="text-end">
                <div
                  v-if="
                    priceRange.minimum_price.final_price.value !=
                    priceRange.maximum_price.final_price.value
                  "
                >
                  <span v-if="product.manufacturer_price.price.value > 0">
                    <strong class="product-price fs-3">
                      {{
                        formatCurrency(product.manufacturer_price.price.value)
                      }}
                    </strong>
                  </span>
                  <div
                    v-if="
                      product.manufacturer_price.price.value == null &&
                      priceRange.maximum_price.regular_price.value >
                        priceRange.minimum_price.final_price.value
                    "
                    class="price-selection"
                  >
                    <span class="normal-price">
                      <s>
                        {{
                          formatCurrency(
                            priceRange.maximum_price.regular_price.value
                          )
                        }}
                      </s>
                    </span>
                  </div>
                  <div class="price-selection">
                    <strong class="product-price fs-3">
                      {{
                        formatCurrency(
                          priceRange.minimum_price.final_price.value
                        )
                      }}
                      -
                      {{
                        formatCurrency(
                          priceRange.maximum_price.final_price.value
                        )
                      }}
                    </strong>
                    <span
                      class="d-block selling-price"
                      v-if="priceRange.minimum_price.discount.percent_off > 0"
                      style="color: #d2101d"
                    >
                      {{ $t("discount") }}
                      {{
                        priceRange.minimum_price.discount.percent_off.toFixed(
                          0
                        )
                      }}%
                    </span>
                    <span
                      class="d-block selling-price"
                      style="color: #d2101d"
                      v-if="
                        priceRange.maximum_price.discount.percent_off >
                        priceRange.minimum_price.discount.percent_off
                      "
                    >
                      {{ $t("to_discount") }}
                      {{
                        priceRange.maximum_price.discount.percent_off.toFixed(
                          0
                        )
                      }}%
                    </span>
                  </div>
                </div>
                <div
                  v-if="
                    priceRange.minimum_price.final_price.value ==
                    priceRange.maximum_price.final_price.value
                  "
                >
                  <span
                    class="normal-price d-block"
                    v-if="product.manufacturer_price.price.value > 0"
                  >
                    <strong class="product-price fs-3">
                      {{
                        formatCurrency(product.manufacturer_price.price.value)
                      }}
                    </strong>
                  </span>
                  <div
                    v-if="
                      priceRange.minimum_price.regular_price.value >
                      priceRange.minimum_price.final_price.value
                    "
                    class="price-selection"
                  >
                    <span class="normal-price">
                      <s>
                        {{
                          formatCurrency(
                            priceRange.minimum_price.regular_price.value
                          )
                        }}
                      </s>
                    </span>
                  </div>
                  <div class="price-selection">
                    <strong class="product-price fs-3">
                      {{
                        formatCurrency(
                          priceRange.minimum_price.final_price.value
                        )
                      }}
                    </strong>
                    <strong
                      class="d-block selling-price"
                      v-if="priceRange.minimum_price.discount.percent_off > 0"
                      style="color: #d2101d"
                    >
                      {{ $t("discount") }}
                      {{
                        priceRange.minimum_price.discount.percent_off.toFixed(
                          0
                        )
                      }}%
                    </strong>
                  </div>
                </div>
              </td>
            </tr>
          </table>
          <div class="my-4 py-2" v-if="!isInStock">
            <span class="in-stock">{{ $t("item_out_of_stock") }}</span>
          </div>
          <div class="my-4 py-2" v-else>
            <span class="in-stock">{{ $t("in_stock") }}</span>
          </div>

          <button
            type="button"
            v-if="isInStock || isBackOrderAvailable"
            v-on:click="addToCart"
            v-bind:disabled="btnDisable"
            :style="buttonClass"
            class="btn btn-primary btn-lg d-block mx-auto mx-md-0 mb-4 px-4 addtocart-btn"
          >
            <ClientOnly
              ><i class="fa-solid fa-basket-shopping me-2"></i
            ></ClientOnly>
            {{ $t("add_to_cart") }}
          </button>

          <div
            class="deliery-info fw-bold"
            v-if="product.DeliveryTime != null"
            :style="'color: ' + product.DeliveryTime.color + '!important'"
          >
            {{ $t("delivery_time") }}: {{ product.DeliveryTime.long
            }}<sup>*</sup>
          </div>

          <div class="mt-4">
            <strong class="d-block">{{ $t("product_information") }}:</strong>
            Model: {{ product.sku }}
          </div>
          <div
            class="product-extra-info"
            v-html="product.description.html"
          ></div>

          <cmsBlockSimple
            v-if="typeof productInformation == 'object'"
            :identifier="productInformation.identifier"
          />
        </form>
      </ClientOnly>
    </div>
  </div>
</template>

<script>
import { Select, Option } from "element-ui";
import { mapGetters } from "vuex";
import { Logger } from "@storefront/core/lib/logger";
import { isServer } from "@storefront/core/helpers";
import ClientOnly from "vue-client-only";
import cmsBlockSimple from "@/esf_antarctica_lederhosenland/core/components/common/BlockSimple.vue";

export default {
  name: "ProductParameters",
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    ClientOnly,
    cmsBlockSimple,
    /*ClientOnly,
    NotifyModal,*/
  },
  props: {
    parameters: { type: Object },
    isInWishList: { type: Boolean },
  },

  computed: {
    ...mapGetters({
      product: "product/getCurrentProduct",
      productConfig: "product/getCurrentConfig",
      options: "product/getCurrentProductOptions",
      customMeasures: "product/getCurrentCustomMeasures",
      compareList: "compare/getProductCompare",
      // getIsProductInCompareList: "compare/getIsProductInCompareList",
      // getCompareProductList: "compare/getCompareProductList",
    }),

    productInformation() {
      return this.$store.getters[`cmsBlock/getCmsBlockByIdentifier`](
        "product_informatie"
      );
    },
    isInStock() {
      if (this.product.stock_status == "IN_STOCK") {
        return true;
      } else {
        return false;
      }
    },
    isBackOrderAvailable() {
      return this.product.backorders_allowed;
    },
    isProductInCompare() {
      return !!this.compareList.find(
        (product) => product.sku === this.product.sku
      );
    },
    getCurrentUrl() {
      if (!isServer) {
        return window.location.href;
      }
      return "";
    },
    btnDisable() {
      if (this.product.__typename == "ConfigurableProduct") {
        const retval = this.$store.getters["product/getCurrentChildSku"];
        if (retval != null) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    buttonClass() {
      if (this.btnDisable == true) {
        return "cursor: not-allowed;";
      } else {
        return "";
      }
    },
    paymentPartners() {
      return this.$store.getters["sliders/getSliderByIdentifier"](
        "payment_providers"
      );
    },
    productBrand() {
      let productBrand = "";
      if (this.product.information_attributes) {
        const brand = this.product.information_attributes.find(
          (item) => item.attribute_code == "merk"
        );
        if (brand) {
          productBrand = brand.value;
        }
      }
      return productBrand;
    },
    finalPrice() {
      if (this.product.__typename == "ConfigurableProduct") {
        if (this.$store.getters["product/getCurrentChildSku"] != null) {
          const found = this.productConfig.variants.find((v) => {
            if (
              v.product.sku == this.$store.getters["product/getCurrentChildSku"]
            ) {
              return true;
            }
          });
          if (found != null) {
            return found.product.price_range.minimum_price.final_price.value.toFixed(
              2
            );
          }
        }
        if (
          this.product.price_range.minimum_price.final_price.value !=
          this.product.price_range.maximum.final_price.value
        ) {
          return (
            this.product.price_range.minimum_price.final_price.value.toFixed(
              2
            ) +
            " - " +
            this.product.price_range.maximum_price.final_price.value
              .toFixed(2)
              .replace(".", ",")
          );
        }
        return this.product.price_range.minimum_price.final_price.value.toFixed(
          2
        );
      }
      if (
        this.product.price_range.minimum_price.final_price.value !=
        this.product.price_range.maximum.final_price.value
      ) {
        return (
          this.product.price_range.minimum_price.final_price.value
            .toFixed(2)
            .replace(".", ",") +
          " - " +
          this.product.price_range.maximum_price.final_price.value
            .toFixed(2)
            .replace(".", ",")
        );
      }
      return this.product.price_range.minimum_price.final_price.value.toFixed(
        2
      );
    },
    priceRange() {
      if (this.product.__typename == "ConfigurableProduct") {
        if (this.$store.getters["product/getCurrentChildSku"] != null) {
          const found = this.productConfig.variants.find((v) => {
            if (
              v.product.sku == this.$store.getters["product/getCurrentChildSku"]
            ) {
              return true;
            }
          });
          if (found != null) {
            return found.product.price_range;
          }
        }
        return this.product.price_range;
      }
      return this.product.price_range;
    },
    availability() {
      if (this.product.__typename == "SimpleProduct") {
        return this.product.store_availability;
      }
      if (this.product.__typename == "ConfigurableProduct") {
        Logger.debug(
          "availability",
          "ProductParameters",
          this.product.__typename
        )();
        if (this.$store.getters["product/getCurrentChildSku"] != null) {
          const found = this.productConfig.variants.find((v) => {
            if (
              v.product.sku == this.$store.getters["product/getCurrentChildSku"]
            ) {
              return true;
            }
          });
          if (found != null) {
            return found.product.store_availability;
          }
        }
      }

      return [];
    },
  },
  data: () => ({
    quantity: 1,
    popup: false,
    addToCartModal: false,
    addToCompareModal: false,
    addToNotifyModal: false,
    priceSize: "",
    tableSize: [
      {
        name: "Billy / BHE",
        sizeS: "49.5 - 54 cm",
        sizeM: "55 - 58 cm",
        sizeL: "n/a",
      },
      {
        name: "Metro / BHE -55",
        sizeS: "n/a",
        sizeM: "55 - 58 cm",
        sizeL: "56 - 61 cm",
      },
      {
        name: "Indra / BHE -56",
        sizeS: "n/a",
        sizeM: "55 - 58 cm",
        sizeL: "58 - 62 cm",
      },
    ],
    fields: [
      {
        key: "name",
        label: "",
      },
      {
        key: "sizeS",
        label: "S",
      },
      {
        key: "sizeM",
        label: "M",
      },
      {
        key: "sizeL",
        label: "L",
      },
    ],
  }),
  methods: {
    // ...mapActions({
    //   updateToggleInCompareList: "compare/updateToggleInCompareList",
    // }),

    async onCompareClick() {
      if (this.isProductInCompare == false) {
        await this.$store.dispatch("compare/addCompareProduct", {
          sku: this.product.sku,
        });
      } else {
        await this.$store.commit("compare/removeCompareProduct", {
          sku: this.product.sku,
        });
      }
    },

    toggleIsInWishList() {
      this.$emit("changeIsInWishList");
    },
    formatCurrency(value) {
      var formatter = new Intl.NumberFormat("nl-NL", {
        style: "currency",
        currency: "EUR",
      });
      return formatter.format(value);
    },
    clickOk() {
      this.addToCartModal = false;
      this.$router.push("/checkout");
    },
    clickCancel() {
      this.addToCartModal = false;
      window.scrollTo(0, 0);
    },

    closeNotifyModal() {
      this.addToNotifyModal = false;
    },
    quantityUp() {
      this.quantity++;
    },
    quantityDown() {
      if (this.quantity > 1) this.quantity--;
    },
    processOption(index, value) {
      Logger.debug("processOption", "ProductParameters", {
        index: index,
        value: value,
      })();
      this.$store.commit("product/setOptionValue", {
        index: index,
        value: value,
      });
    },
    addToNotify() {
      this.addToNotifyModal = true;
    },
    getGTMItems() {
      let items = {
        item_name: this.product.name,
        item_id: this.product.sku,
        quantity: this.quantity,
        price: this.regularPrice,
        item_brand: this.productBrand,
        discount: this.regularPrice - this.finalPrice,
      };
      return items;
    },
    async addToCart() {
      switch (this.product.__typename) {
        case "SimpleProduct": {
          const item =
            '{data: {sku: "' +
            this.product.sku +
            '", quantity:' +
            this.quantity +
            "}}  ";
          let retval = await this.$store.dispatch("cart/addToCart", {
            type: this.product.__typename,
            item: item,
          });
          Logger.debug("retval", "addToCart", retval)();
          if (retval == false) {
            const msg = {
              type: "danger",
              title: this.$t("shopping_basket"),
              text: this.$t("not_add_product"),
            };
            this.$store.dispatch("messages/sendMessage", { message: msg });
          } else {
            if (this.$gtm.enabled()) {
              Logger.debug("Watch Product", "product.vue", "CALLED")();
              if (!this.$gtm.uaDisabled) {
                window.dataLayer.push({
                  event: "eec.add",
                  ecommerce: {
                    add: {
                      currency: "EUR",
                      value: this.finalPrice,
                      products: [
                        {
                          name: this.product.name,
                          id: this.product.sku,
                          quantity: this.quantity,
                        },
                      ],
                    },
                  },
                });
              }
              if (this.$gtm.ga4Enabled) {
                window.dataLayer.push({
                  event: "add_to_cart",
                  ecommerce: {
                    add: {
                      currency: "EUR",
                      value: this.finalPrice,
                      items: [this.getGTMItems()],
                    },
                  },
                });
              }
            }
            this.addToCartModal = true;
            // this.$bvModal.show(`modal-${this.product.sku}`);
          }
          break;
        }
        case "ConfigurableProduct": {
          const item =
            '{ parent_sku: "' +
            this.product.sku +
            '" data: {sku: "' +
            this.$store.getters["product/getCurrentChildSku"] +
            '", quantity:' +
            this.quantity +
            "}}  ";
          let retval = await this.$store.dispatch("cart/addToCart", {
            type: this.product.__typename,
            item: item,
          });
          Logger.debug("retval", "addToCart", retval)();
          if (retval == false) {
            const msg = {
              type: "danger",
              title: this.$t("add_to_cart"),
              text: this.$t("not_add_product"),
            };
            this.$store.dispatch("messages/sendMessage", { message: msg });
          } else {
            if (this.$gtm.enabled()) {
              Logger.debug("Watch Product", "product.vue", "CALLED")();
              //GA event
              window.dataLayer.push({
                event: "eec.add",
                ecommerce: {
                  add: {
                    products: [
                      {
                        name: this.product.name,
                        id: this.product.sku,
                        quantity: this.quantity,
                      },
                    ],
                  },
                },
              });
              if (this.$gtm.ga4Enabled) {
                //GA4 event
                window.dataLayer.push({
                  event: "add_to_cart",
                  ecommerce: {
                    add: {
                      currency: "EUR",
                      value: this.finalPrice,
                      items: [this.getGTMItems()],
                    },
                  },
                });
              }
            }
            this.addToCartModal = true;
            // this.$bvModal.show("modal-1");
          }
          break;
        }

        default:
          break;
      }
    },
    getUniqueOptions(options) {
      const seen = new Set();
      return options.filter((opt) => {
        const key = opt.value_index; // or `${opt.label}-${opt.value_index}` if needed
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      });
    },
  },
};
</script>

